import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { ApiUtils } from '@shared/utils';
import { IntegrationsApi, RequestStrategyEnum, type WithSignal, type AccountTypeFieldResponse } from '@shared/api';

const getAccountTypesEffect = createEffect(({ signal }: WithSignal = {}) => IntegrationsApi.getAccountTypes(signal));
const clearEvent = createEvent();

const $dataStore = createStore<AccountTypeFieldResponse | null>(null)
  .on(getAccountTypesEffect.done, (current, data) => data.result.data ?? current)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getAccountTypesEffect.pending, (_, data) => data)
  .on(getAccountTypesEffect.fail, (_, data) => ApiUtils.abortApiLoadingFailCaseTrigger(data.error))
  .on(getAccountTypesEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getAccountTypesEffect, () => null)
  // .on(getAccountTypesEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getAccountTypesEffect.fail, (_, data) =>
    ApiUtils.abortApiErrorFailCaseTrigger(data.error, 'Something went wrong while fetching Account Types. Please try again.'),
  )
  .on(getAccountTypesEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((x) => $notificationStore.events.setError(x));

const getAccountTypesApi = ApiUtils.wrapperApi(getAccountTypesEffect, RequestStrategyEnum.Abort);
clearEvent.watch(() => getAccountTypesApi.cancel());

export const $accountTypesStore = {
  events: {
    getAccountTypes: getAccountTypesApi.trigger,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
